'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _lodash = require('lodash');

var _retry = require('../utilities/retry');

var _retry2 = _interopRequireDefault(_retry);

var _poller = require('../utilities/poller');

var _poller2 = _interopRequireDefault(_poller);

var _constants = require('../constants');

var _currencyExchangeRates = require('../actions/currencyExchangeRates');

var _actionTypes = require('../actionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Responsible for fetching ETH/fiat exchange rates on an interval.
 */
exports.default = function (_ref) {
  var fetchCurrencyExchangeRates = _ref.fetchCurrencyExchangeRates;
  return function (store) {
    var dispatch = store.dispatch;

    return (0, _poller2.default)(store, {
      initialState: { currentRates: {} },

      frequency: _constants.EXCHANGE_RATE_REFRESH_INTERVAL,

      checkStart: function checkStart(action) {
        return action.type === _actionTypes.APP_INIT;
      },

      checkStop: function checkStop(action) {
        return action.type === _actionTypes.APP_SHUTDOWN;
      },

      main: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(pollerState) {
          var currentRates, nextRates;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  currentRates = pollerState.currentRates;
                  _context.prev = 1;
                  _context.next = 4;
                  return (0, _retry2.default)(function () {
                    return fetchCurrencyExchangeRates(_constants.COINGECKO_API_ETH_ID, _constants.CURRENCY_CODES);
                  }, {
                    delay: (0, _retry.exponentialBackoff)()
                  });

                case 4:
                  nextRates = _context.sent;

                  if (!(0, _lodash.isEqual)(nextRates, currentRates)) {
                    dispatch((0, _currencyExchangeRates.ethExchangeRatesFetched)(nextRates));
                    currentRates = nextRates;
                  }
                  _context.next = 11;
                  break;

                case 8:
                  _context.prev = 8;
                  _context.t0 = _context['catch'](1);

                  dispatch((0, _currencyExchangeRates.ethExchangeRatesFetchFailed)(_context.t0));

                case 11:
                  return _context.abrupt('return', { currentRates: currentRates });

                case 12:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[1, 8]]);
        }));

        function main(_x) {
          return _ref2.apply(this, arguments);
        }

        return main;
      }()
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/middleware/pollEthCurrencyExchangeRates.js
// module id = 1299
// module chunks = 0